import { render, staticRenderFns } from "./boast.vue?vue&type=template&id=1f370f54&scoped=true"
import script from "./boast.vue?vue&type=script&lang=js"
export * from "./boast.vue?vue&type=script&lang=js"
import style0 from "./boast.vue?vue&type=style&index=0&id=1f370f54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f370f54",
  null
  
)

export default component.exports